module.exports = __webpack_public_path__ + "static/img/health_card_add.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/health_card_add.png
// module id = 549
// module chunks = 0